'use strict';

export default function promiseRAF(count = 1) {
    count = parseInt(count);
    return function (value) {
        return new Promise(function (resolve) {
            (function raf() {
                count-- ? requestAnimationFrame(raf) : resolve(value);
            })();
        });
    };
}